// Decide whether to show the senior "$99 Buy All your photos" upsell after a print/
// package is built. Kept as a pure function so the gate is unit-testable.
//
// Hidden when ANY of:
//   - no promo option is configured for this package (nothing to upsell), OR
//   - the cart already carries a senior buy-all line (hasSeniorBuyAll), OR
//   - the customer JUST built the full-price "All Digital" package — that is the SAME
//     all-images product the $99 promo sells, so offering $99 for images they just
//     bought at full price is confusing. The built option is `builtOptionId`; the
//     regular all-digital option (useBuyAllOption) is `allDigitalOption`.
//
// `builtOptionId` arrives as a STRING from the URL query while option ids are numbers,
// so compare as strings.
export default function shouldShowBuyAllPromo({
  buyAllPromoOption,
  hasSeniorBuyAll,
  builtOptionId,
  allDigitalOption,
}) {
  if (!buyAllPromoOption) return false;
  if (hasSeniorBuyAll) return false;

  const boughtAllDigital = !!allDigitalOption
    && String(builtOptionId) === String(allDigitalOption.id);
  if (boughtAllDigital) return false;

  return true;
}
